import React from 'react';
import { Paper } from 'library';
import { useProviderProfileContext } from '../../ProviderProfileContext';
import PreviousChildcareCenterJobExperience from './PreviousChildcareCenterExperience';
import ChildcareCenterExperienceSpecifics from './ChildcareCenterExperienceSpecifics';

export default function ProviderProfileBusinessExperienceTab() {
    const { providerQualifications } = useProviderProfileContext();
    return (
        <>
            <Paper>
                <PreviousChildcareCenterJobExperience employment={providerQualifications.employment} />
                <ChildcareCenterExperienceSpecifics />
            </Paper>
        </>
    );
}
